import React from 'react';

const ProfileHeader = () => {
    return (
        <div>
            <h1>Profile</h1>
        </div>
    );
};

export default ProfileHeader;
